// extracted by mini-css-extract-plugin
export default {"balloon":"MapPoint_balloon__0LAoD","myBalun":"MapPoint_myBalun__spuko"};